<!--课程预告-->
<template>
    <div class="sec courseNotice">
        <el-tabs v-model="activeName">
            <el-tab-pane name="first">
                <template v-slot:label>
                    <div class="tabTitle myflex-v">
                        <i class="el-icon-pie-chart title-icon myhide"></i><img src="@/assets/img/icon2.png" class="title-icon-img" />课程预告</div>
                </template>
                <template>
                    <div class="box" v-if="courseList.length>0">
                        <div class="list-item w-100 myflex-v" v-for="(cItem1,cIndex1) in courseList" :key="cIndex1">
                            <i class="dot"></i>
                            <div class="list-text marginauto-l flex1 myflex-v">
                                <div class="ellipsis1 flex1 list-course">{{cItem1.courseName}}</div>
                                <span class="time-box">上架时间：{{art.formatDate(cItem1.publishTime,2)}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="nodata pad15">暂无数据~</div>
                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<style lang="scss" scoped>
    .courseNotice{height:240px;}
    .dot{width:5px;height:5px;background:$theme-color;margin:0 10px 0 20px;}
    .time-box{width:130px;min-width:130px;font-size:12px;color:#5e686f;}
    .list-item{}
    .list-text{border-bottom:1px dashed #ddd;padding:10px 0px 10px 0;margin-right:15px;}
    .list-course{width:390px;margin-right:10px;}
    .box{height:175px;padding-bottom:15px;overflow-y:auto;}
</style>

<script>
import CourseListItem from '@/components/CourseListItem.vue';
export default {
    name: "shequCourse",
    components: {
        CourseListItem,
    },
    data(){
        return {
            art: art,
            activeName: 'first',
            courseList:[],
        }
    },
    methods: {
        //获取列表
        getList(){
            this.$api.web.websitContentGetCourseNoticeList({pageSize:4,pageNum:1}).then(res=>{
                this.courseList = res.body.courseNoticeList;
            }).catch(res=>{})
        },

    },
    created(){
    },
    mounted(){
        setTimeout(() => {
           this.getList(); 
        }, 1300);
    },

}
</script>